import { API_BASE_URL } from "./config";

const ABSOLUTE_URL_PATTERN = /^[a-z][a-z0-9+.-]*:/i;

const appendCacheBuster = (url, cacheKey) => {
  if (!url || cacheKey === undefined || cacheKey === null || cacheKey === "") {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${encodeURIComponent(cacheKey)}`;
};

export const toPublicAssetUrl = (url, options = {}) => {
  const { fallback = null, cacheKey = null } = options;

  if (typeof url !== "string") {
    return fallback;
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return fallback;
  }

  if (ABSOLUTE_URL_PATTERN.test(trimmed)) {
    return appendCacheBuster(trimmed, cacheKey);
  }

  if (trimmed.startsWith("/uploads/")) {
    return appendCacheBuster(`${API_BASE_URL}${trimmed}`, cacheKey);
  }

  if (trimmed.startsWith("uploads/")) {
    return appendCacheBuster(`${API_BASE_URL}/${trimmed}`, cacheKey);
  }

  return fallback;
};
